/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

export type SavedViewType =
  | "projects"
  | "clients"
  | "contacts"
  | "estimates"
  | "proposals"
  | "suppliers"
  | "cost-profiles"
  | "services"
  | "documents"
  | "materials"
  | "equipment"
  | "labor-rates"
  | "pipeline"
  | "invoices"
  | "subcontractors"
  | "audit-logs";

export function getSavedViewsEndpoint(viewType: SavedViewType): string {
  if (viewType === "projects") {
    return "/api/projects/views";
  }
  if (viewType === "suppliers") {
    return "/api/suppliers/views";
  }
  return "/api/clients/views";
}
